<template>
    <v-dialog
        v-model="dialog"
        :max-width="maxWidth"
        :scrollable="scrollable"
        :retain-focus="false"
    >
        <v-card>
            <v-toolbar color="primary" dark>
                <v-icon v-if="icon" color="white" class="mr-2">{{ icon }}</v-icon>
                <v-toolbar-title>{{ title }}</v-toolbar-title>
                <v-spacer />
                <slot name="toolbar-append" />
                <v-btn icon @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>

            <slot />
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'SysTeacherHubModal',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            required: true
        },
        icon: {
            type: String,
            default: null
        },
        maxWidth: {
            type: [String, Number],
            default: 1200
        },
        scrollable: {
            type: Boolean,
            default: true
        }
    },
    data: () => ({
        dialog: false
    }),
    watch: {
        show(value) {
            this.dialog = value
        },
        dialog(value) {
            this.$emit('update:show', value)
        }
    }
}
</script>
